import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("constant");

export default {
  computed: {
    ...mapState(["states", "countries"])
  }
};
